(() => {
  const root = window.Shopify?.routes?.root || '/';

  document.addEventListener('click', async event => {
    const strength = event.target.closest('[data-saloon-variant]');
    if (strength) {
      const card = strength.closest('[data-saloon-card-add]');
      if (!card || strength.disabled) return;
      card.querySelectorAll('[data-saloon-variant]').forEach(choice => {
        const selected = choice === strength;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', String(selected));
      });
      card.querySelector('[data-saloon-add]').dataset.variantId = strength.dataset.saloonVariant;
      const status = card.querySelector('[data-saloon-add-status]');
      status.textContent = '';
      status.classList.remove('is-error');
      return;
    }

    const add = event.target.closest('[data-saloon-add]');
    if (!add || add.disabled || !add.dataset.variantId) return;
    const card = add.closest('[data-saloon-card-add]');
    const status = card.querySelector('[data-saloon-add-status]');
    add.disabled = true;
    add.textContent = 'Adding…';
    status.textContent = '';
    status.classList.remove('is-error');

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.variantId), quantity: 1 }], sections: ['ajax-cart-drawer'] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Could not add this flavour.');

      const drawerBody = document.querySelector('[data-cart-drwaer-body]');
      const drawerHtml = result.sections?.['ajax-cart-drawer'];
      if (drawerBody && drawerHtml) {
        const section = new DOMParser().parseFromString(drawerHtml, 'text/html').querySelector('.shopify-section');
        if (section) {
          drawerBody.innerHTML = section.innerHTML;
          if (typeof getQuantityElement === 'function') getQuantityElement(drawerBody);
          if (typeof getCartItemRemoveElements === 'function') getCartItemRemoveElements(document.querySelector('#ajax-cart-drawer'));
          if (typeof cartGiftWrapElement === 'function') cartGiftWrapElement(document.querySelector('#ajax-cart-drawer'));
        }
      }

      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-header-cart-count]').forEach(count => {
          count.textContent = cart.item_count > 99 ? '' : String(cart.item_count);
          count.classList.toggle('hidden', cart.item_count === 0);
        });
        const cartWrapper = document.querySelector('[data-cart-wrapper]');
        if (cartWrapper) cartWrapper.dataset.itemCount = cart.item_count;
      }
      status.append('Added. Keep choosing flavours or ');
      const link = document.createElement('a');
      link.href = `${root}cart`;
      link.textContent = 'view basket';
      status.append(link, '.');
    } catch (error) {
      status.textContent = error.message || 'Could not add this flavour. Please try again.';
      status.classList.add('is-error');
    } finally {
      add.disabled = false;
      add.textContent = 'Add to basket';
    }
  }, true);
})();
